module.exports = __webpack_public_path__ + "static/img/nawiDalej-ON.21c1cf30.png";